import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { orderBy, keyBy, isEmpty } from 'lodash';
import CollectionSliderCard from './CollectionSliderCard';
import WidgetCarousel from './WidgetCarousel';
import { LEARNING_ASSET_TYPES, PRACTICAL_APP_OVERLAYS } from '../../../shared/Constants';
import { statusAccessor } from '../../../shared/utils/AccessorUtils';

export default class CollectionSlider extends Component {
    static propTypes = {
        cardClassName: PropTypes.string,
        collections: PropTypes.array,
        userCollections: PropTypes.array,
        isReadOnly: PropTypes.bool,
        loading: PropTypes.bool,
        cardOrientation: PropTypes.string,
        orderedCollections: PropTypes.array,
        isCollectionsOrderLocked: PropTypes.bool,
        onCardClick: PropTypes.func,
        handleRecommendationModalOpen: PropTypes.func,
        slidesToShow: PropTypes.number,
        cardThumbnailDimension: PropTypes.object,
        addons: PropTypes.array,
        customAccessor: PropTypes.array,
        userLearningAssetsById: PropTypes.object,
        skipSort: PropTypes.bool
    };

    _getCollectionsToDisplay = (collections, userCollections, skipSort = false) => {
        const { isCollectionsOrderLocked, orderedCollections, customAccessor = [statusAccessor] } = this.props;

        const markedUserCollections = userCollections.map((item) => {
            item.isUserCollection = true;
            return item;
        });
        let collectionsToDisplay;
        if (isCollectionsOrderLocked && orderedCollections) {
            const userCollectionsByCollectionId = keyBy(userCollections, 'collectionId');

            collectionsToDisplay = orderedCollections.map((collection) => {
                if (userCollectionsByCollectionId[collection._id]) {
                    return userCollectionsByCollectionId[collection._id];
                }
                return collection;
            });
        } else if (skipSort) {
            collectionsToDisplay = [...markedUserCollections, ...collections];
        } else {
            collectionsToDisplay = orderBy([...markedUserCollections, ...collections], ...customAccessor);
        }
        return collectionsToDisplay;
    };

    render() {
        const {
            collections = [],
            userCollections = [],
            addons = [],
            cardOrientation = 'vertical',
            loading,
            cardClassName = 'col-12',
            isReadOnly,
            handleRecommendationModalOpen,
            onCardClick,
            slidesToShow = 4.2,
            cardThumbnailDimension,
            userLearningAssetsById = {}
        } = this.props;

        const cards = this._getCollectionsToDisplay(collections, userCollections, this.props.skipSort).map((collection) => {
            return (
                <div
                    key={collection._id}
                    onClick={() => {
                        onCardClick(collection);
                    }}
                >
                    <CollectionSliderCard
                        cardOrientation={cardOrientation}
                        handleRecommendationModalOpen={handleRecommendationModalOpen}
                        isUserCollection={collection.isUserCollection}
                        collection={collection}
                        loading={loading}
                        className={cardOrientation === 'vertical' ? cardClassName : 'col-12 col-sm-6'}
                        isReadOnly={isReadOnly || collection.isLocked}
                        thumbnailDimension={cardThumbnailDimension} // the actual size of the fetched image. This should ideally be larger than the card
                        userLearningAssetsById={userLearningAssetsById}
                    />
                </div>
            );
        });

        return (
            <WidgetCarousel
                className={'vertical-cards'}
                displayItems={[...cards, ...addons]}
                carouselSettings={`verticalCards-${slidesToShow}`}
                disableCarousel={cardOrientation !== 'vertical'}
            />
        );
    }
}
